import pascal from "refractor/pascal";
export default pascal;